import React from 'react';
import styles from '../AiDialog.module.css';

export function DialogFooter({
  selectedValue,
  suggestions,
  onClose,
  onSelect,
  selectButtonLabel = 'Select',
}) {
  return (
    <div className={styles.footer}>
      <button type='button' onClick={onClose} className={styles.footerCloseBtn}>
        Close
      </button>
      <button
        type='button'
        disabled={!selectedValue?.trim() || !suggestions.length}
        onClick={onSelect}
        className={styles.footerSelectBtn}
      >
        {selectButtonLabel}
      </button>
    </div>
  );
}
